

export function getSettingMenuItems({
    disableMyChartMenuItems,
    enableHappyTogether,
    isMyChartUser,
    isPrimaryUser,
    notPharmacyProxy
}) {

    return {
        show: true,
        navHead: {
            label: 'Account Settings',
            url: null,
            icon: 'settings'
        },
        navItems: [
            {
                label: 'Login Settings',
                show: isPrimaryUser,
                url: '/loginsettings',
                subMenuItems: null
            },
            {
                label: 'Family Account Management',
                show: isPrimaryUser,
                url: '/proxymanagement',
                altUrls: ['/proxyrequestdob', "/proxyrequest", "/grantaccessproxy", "/acceptproxy"],
                subMenuItems: null
            },
            {
                label: 'Manage Accounts & Access',
                show: isPrimaryUser || (isMyChartUser && enableHappyTogether), 
                disabled: !isPrimaryUser && (isMyChartUser && enableHappyTogether) && disableMyChartMenuItems,
                url: '/manageaccountslanding',
                subMenuItems:  {
                    menuLabel: "Manage Accounts & Access",
                    menuItems: [
                        {
                            label: 'Community Accounts',
                            show: isMyChartUser && enableHappyTogether,
                            disabled: disableMyChartMenuItems,
                            url: '/communitymanage',
                        },
                        {
                            label: 'Linked Accounts',
                            show: isPrimaryUser, //Temporarilty hiding for proxies until data tile can be fixed
                            url: '/linkedaccounts'
                        },
                        {
                            label: 'App and Device Access',
                            show: isPrimaryUser, //Temporarilty hiding for proxies until data tile can be fixed
                            url: '/linkeddevices'
                        },

                    ]
                } 
            },
            {
                label: 'Notifications',
                show: notPharmacyProxy,
                url: '/notifications',
                altUrls: ['/preferencesettings'],
                subMenuItems: null
            },
            {
                label: "Need Help?",
                show: true,
                url: '/faq',
                subMenuItems: null
            }
        ]
    };
}